var quizApp = new Vue({
    el: '#fact-central-article',
    data: {
        currentStep: 1,
        stepCount: 0,
        progressBarWidth: 0,
        pageIndicator: '#step-'
    },
    computed: {
        disableNextButton: function() {
            return this.stepCount === 0 || this.currentStep === this.stepCount;
        }
    },
    methods: {
        nextStep() {
            if (this.currentStep < this.stepCount) {
                this.currentStep++;

                this.calculateProgressBarWidth();
                this.updateHref();
                this.scrollToTop();
            }
        },
        previousStep() {
            if (this.currentStep > 1) {
                this.currentStep--;

                this.calculateProgressBarWidth();
                this.updateHref();
                this.scrollToTop();
            }
        },
        scrollToTop() {
            $('html,body').animate({scrollTop: 0},'slow');
            // $(window).scrollTop($("#fact-central-article").offsetTop);
        },
        calculateProgressBarWidth() {
            this.progressBarWidth = this.currentStep / this.stepCount * 100;
        },
        updateHref() {
            let url = window.location.href;
            let newUrl;
            let existingPageIndicatorIndex;

            existingPageIndicatorIndex = url.indexOf(this.pageIndicator);

            if (existingPageIndicatorIndex !== -1) {
                url = url.substring(0, existingPageIndicatorIndex);
            }

            newUrl = url + '#step-' + this.currentStep;

            window.location.href = newUrl;
        },
        // Detect if there is a step in the URL
        parseStepFromUrl() {
            let existingPageIndicatorIndex;
            let url;
            let parsedStep;

            url = window.location.href;
            existingPageIndicatorIndex = url.indexOf(this.pageIndicator);

            if (existingPageIndicatorIndex !== -1) {
                parsedStep = url.substring(existingPageIndicatorIndex + this.pageIndicator.length);

                if (parsedStep.length > 0) {
                    parsedStep = +parsedStep;

                    // Make sure the parsed step is within the expected range
                    if (parsedStep > 0 && parsedStep <= this.stepCount) {
                        this.currentStep = parsedStep;
                    }
                }
            } else {
                this.currentStep = 1;
            }
        }
    },
    created: function() {
        var self = this;
        this.stepCount = factCentralArticle.stepCount;
        this.parseStepFromUrl();
        this.calculateProgressBarWidth();

        // This detects changes to the # portion of the URL, allowing us to detect if the 'back' or 'forward' buttons were pressed, and navigating accordingly to the correct step in the article.
        window.onhashchange = function() {
            self.parseStepFromUrl();
            self.calculateProgressBarWidth();
        };
    }
});